/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import common from "@/request/api/common";

const bucket = {
    // 获取用户购物车商品列表信息    
    getUserBucketGoodsInfo(params) {
        return axios.post('/goods/mobileBucket/getUserBucketInfo', qs.stringify(params));
    },
    //修改用户购物车数量
    updateBucketNum(params) {
        return axios.post('/goods/mobileBucket/changeBucketNum', qs.stringify(params));
    },
    //添加用户购物车
    addBucketInfo(params) {
        const userLevelId = localStorage.getItem('userLevelId') || ''
        params.userLevelId = userLevelId
        return axios.post('/goods/mobileBucket/addBucketInfo', qs.stringify(params));
    },
    //减少购物车信息数量信息
    descbucketInfo(params){
        return axios.post('/goods/mobileBucket/descbucketInfo', qs.stringify(params));
    },
    //特价活动商品加入购物车
    addSpecialGoodsBucket(params) {
        return axios.post('/goods/mobileBucket/addSpecialBucketInfo', qs.stringify(params));
    },
    //组合套餐活动商品加入购物车
    addPackageBucketInfo(params) {
        return axios.post('/goods/mobileBucket/addPackageBucketInfo', qs.stringify(params));
    },
    //减少购物车组合套餐的数量信息
    descPackageBucketInfo(params) {
        return axios.post('/goods/mobileBucket/descPackageBucketInfo', qs.stringify(params));
    },
    //获取结算页面商品信息列表
    getPayGoodsInfoByBucketId(params) {
        return axios.post('/goods/mobileBucket/getPayGoodsInfoByBucketId', params);
    },
    //删除购物车信息信息
    async deleteBucketInfoByBucketIdList(params) {
        const userDetailInfo = await common.getUser() || {}
        params.companyId = userDetailInfo.companyId || ''
        params.userId = userDetailInfo.userId || ''
        return axios.post('/goods/mobileBucket/deleteBucketInfoByBucketIdList', qs.stringify(params));
    },
    //获取结算页面可用优惠券列表信息
    getPayCouponList(params) {
        return axios.post('/goods/mobileBucket/getPayCouponList', qs.stringify(params));
    },
    //获取用户购物车数量
    getBucketNum(params) {
        return axios.post('/goods/mobileBucket/getBucketNum', qs.stringify(params));
    },
    //修改组合套餐购物车数量
    changePackageBucketNum(params) {
        return axios.post('/goods/mobileBucket/changePackageBucketNum', qs.stringify(params));
    },
    //购物车商品加入收藏
    collectBucketGoods(params) {
        return axios.post('/goods/mobileGoods/collectBucketGoods', qs.stringify(params));
    },
    //获取赠送商品信息
    getAllDonateGoods(params) {
        return axios.post('/goods/mobileBucket/getAllDonateGoods', qs.stringify(params));
    },
    //获取所有满足条件订单促销活动
    getAllOrderPromotion(params) {
        return axios.post('/goods/mobileBucket/getAllOrderPromotion', qs.stringify(params));
    },
    //获取所有订单促销赠送商品信息
    getPromotionGoodsByRule(params) {
        return axios.post('/goods/mobileBucket/getPromotionGoodsByRule', qs.stringify(params));
    },
    //获取退货车所有信息
    getShopRefundList(params) {
        return axios.post('/goods/shopRefund/getShopRefundList', qs.stringify(params));
    },
    //用户添加商品到退货车
    addUserRefundBucket(params) {
        return axios.post('/goods/shopRefund/addUserRefundBucket', qs.stringify(params));
    },
    //删除退货车信息
    delUserRefundBucket(params) {
        return axios.post('/goods/shopRefund/delUserRefundBucket', qs.stringify(params));
    },
    //PC 端天极爱购物车接口
    addPcBucketInfo(params) {
        return axios.post('/goods/shopBucket/addUserBucket', qs.stringify(params));
    },
    //请求威支付唯一凭证接口以及二维码地址
    getBwPayCodeUrl(params) {
        return axios.post('/order/wzfPay/getBwPayCodeUrl', qs.stringify(params));
    },
    //查询交易结果信息
    getPayResult(params) {
        return axios.post('/order/wzfPay/getPayResult', qs.stringify(params));
    },
    //关闭威支付订单
    closePayOrder(params) {
        return axios.post('/order/wzfPay/closePayOrder', qs.stringify(params));
    },
    getFundConfig(params) {
        return axios.post('/order/sysConfig/getFundConfig', qs.stringify(params));
    },
    //不对接系统配置信息
    getCompanyConfig(params){
        return axios.post('/order/companyConfiguration/getCompanyConfiguration', qs.stringify(params));
    },
    //获取赠送的购物券
    getAllGivenCoupons(params){
        return axios.post('/goods/mobileBucket/getAllGivenCoupons', qs.stringify(params));
    },
    //购物车活动商品更新数量接口
    updateActivityBucket(params){
        return axios.post('/goods/shopBucket/updateActivityBucket', qs.stringify(params));
    },
    
}

export default bucket;


// WEBPACK FOOTER //
// ./src/request/api/bucket/bucket.js